import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en.json';
import fr from './fr.json';

export const defaultLocale = 'fr';

Vue.use(VueI18n);

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {
    en,
    fr,
  },
});
